import { useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_USER_PROFILES_BY_YEAR } from '@/api/endpoints';
import { USER_PROFILES_QUERY_KEY } from '@/api/queryKeys';
import type { UserProfilesResponse } from '@/types/user';
import { unwrapAxiosResponse } from '@/utils/axios';
import { ErrorMessage, logRequestError } from '@/utils/errors';

export const useRefreshProfiles = () => {
  const queryClient = useQueryClient();

  return async () => {
    try {
      const profiles = await apiClient
        .get<UserProfilesResponse>(API_USER_PROFILES_BY_YEAR)
        .then(unwrapAxiosResponse);

      queryClient.setQueryData(USER_PROFILES_QUERY_KEY, profiles);
    } catch (error) {
      logRequestError(ErrorMessage.RefreshProfiles, error);
    }
  };
};
